module.exports = __webpack_public_path__ + "img/introductionBgImg4.facb5f68.png";